import React from 'react';
import BaseModal from '../common/BaseModal';

const PriceChangeModal = ({
  show,
  onClose,
  selectedProducts,
  priceChangeMode,
  setPriceChangeMode,
  priceChangeValue,
  setPriceChangeValue,
  roundToPsychological,
  setRoundToPsychological,
  onApply,
  loading,
}) => {
  const footerButtons = (
    <>
      <button onClick={onClose} style={{
        padding: '6px 12px', fontSize: '12px', border: '1px solid var(--text-muted)',
        color: 'var(--text-muted)'
      }}>Anuluj</button>
      <button onClick={onApply} disabled={loading || !priceChangeValue} style={{
        padding: '6px 12px', fontSize: '12px',
        border: `1px solid ${loading || !priceChangeValue ? 'var(--border)' : 'var(--success)'}`,
        color: loading || !priceChangeValue ? 'var(--text-muted)' : 'var(--success)',
        opacity: loading || !priceChangeValue ? 0.6 : 1
      }}>
        {loading ? '⏳ Zapisywanie...' : '✓ Zastosuj zmiany'}
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={show}
      onClose={onClose}
      title={'💰 Zmiana cen'}
      subtitle={`${selectedProducts.size} produktów wybranych`}
      size="md"
      headerStyle={{
        border: '1px solid var(--success)',
        color: 'var(--success)'
      }}
      footer={footerButtons}
    >
      {/* Typ zmiany */}
      <div style={{ marginBottom: '1rem' }}>
        <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
          Typ zmiany:
        </div>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          {[
            { id: 'fixed', label: 'Ustaw cenę', icon: '🎯' },
            { id: 'margin', label: 'Marża (%)', icon: '📈' },
            { id: 'percent', label: 'Procent (%)', icon: '📊' },
            { id: 'amount', label: 'Zmień kwotę', icon: '💵' }
          ].map(opt => (
            <button key={opt.id} onClick={() => setPriceChangeMode(opt.id)} style={{
              flex: 1, padding: '6px 12px', fontSize: '11px', fontWeight: '500',
              border: priceChangeMode === opt.id ? '2px solid var(--success)' : '1px solid var(--border)',
              cursor: 'pointer',
              backgroundColor: priceChangeMode === opt.id ? 'var(--success-light)' : 'var(--card-bg)' ,
              color: priceChangeMode === opt.id ? 'var(--success)' : 'var(--text-secondary)'
            }}>
              {opt.icon} {opt.label}
            </button>
          ))}
        </div>
      </div>

      {/* Wartość */}
      <div style={{ marginBottom: '1rem' }}>
        <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
          {priceChangeMode === 'amount' && 'Zmiana ceny (zł):'}
          {priceChangeMode === 'percent' && 'Zmiana procentowa (%):'}
          {priceChangeMode === 'margin' && 'Docelowa marża (%):'}
          {priceChangeMode === 'fixed' && 'Docelowa cena brutto (zł):'}
        </div>
        <input type="number" step="0.01" value={priceChangeValue}
          onChange={(e) => setPriceChangeValue(e.target.value)}
          placeholder={
            priceChangeMode === 'amount' ? 'np. 5.00 lub -2.50' :
            priceChangeMode === 'percent' ? 'np. 10 lub -15' :
            priceChangeMode === 'fixed' ? 'np. 12.99' : 'np. 25'
          }
          style={{
            width: '100%', padding: '0.75rem', fontSize: '14px', fontWeight: '500',
            border: '2px solid var(--border)', borderRadius: '8px', textAlign: 'center'
          }}
        />
        <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '0.25rem' }}>
          {priceChangeMode === 'amount' && 'Dodaj lub odejmij określoną kwotę od aktualnej ceny'}
          {priceChangeMode === 'percent' && 'Zwiększ lub zmniejsz cenę o określony procent'}
          {priceChangeMode === 'margin' && 'Marża 40% = 40% ceny sprzedaży to Twój zysk'}
          {priceChangeMode === 'fixed' && 'Ustaw dokładną cenę brutto dla wybranych produktów'}
        </div>
      </div>

      {/* Zaokrąglenie */}
      <div style={{
        backgroundColor: 'var(--warning-light)', borderRadius: '8px', padding: '0.75rem',
        border: '1px solid var(--warning)'
      }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', cursor: 'pointer' }}>
          <input type="checkbox" checked={roundToPsychological}
            onChange={(e) => setRoundToPsychological(e.target.checked)}
            style={{ accentColor: 'var(--warning)', width: '16px', height: '16px' }} />
          <span style={{ fontWeight: '500' }}>Zaokrąglij do cen psychologicznych (.99)</span>
        </label>
        <div style={{ fontSize: '10px', color: 'var(--warning)', marginTop: '0.25rem', marginLeft: '24px' }}>
          np. 12.50 {'→'} 12.99
        </div>
      </div>
    </BaseModal>
  );
};

export default PriceChangeModal;
